import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "留言讨论" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-background-200 bg-background-100 text-foreground-600">
      <div className="container-x grid grid-cols-1 gap-10 py-12 sm:grid-cols-2 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-sword-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-ink text-xl text-primary-700">师兄啊师兄</span>
              <span className="mt-0.5 text-[11px] tracking-widest text-foreground-400">剧情讨论区</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed">
            专注《师兄啊师兄》漫画的剧情讨论与内容梳理。宗门篇脉络、修炼境界体系、主线走向与伏笔盘点，同好陪你一起聊透、追更不迷路。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-bilibili-line", "ri-weibo-line", "ri-wechat-2-line", "ri-douban-line"].map((icon) => (
              <a
                key={icon}
                href="#!"
                onClick={(e) => e.preventDefault()}
                aria-label="关注我们"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600"
              >
                <i className={`${icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-900">栏目导航</h3>
          <ul className="mt-4 space-y-3">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/section/${c.slug}`} className="text-sm transition-colors hover:text-primary-600">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-900">关于本站</h3>
          <ul className="mt-4 space-y-3">
            {aboutLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm transition-colors hover:text-primary-600">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-xs leading-relaxed text-foreground-400">
            追更提醒：最新章节请认准漫画官方连载平台，支持正版。
          </p>
        </div>
      </div>

      <div className="border-t border-background-200/80">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-5 text-xs text-foreground-400 sm:flex-row">
          <p>© 2026 师兄啊师兄讨论区 · 仅供同好交流与剧情梳理使用</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-line text-primary-400"></i>
            陪你一路追更，江湖再见
          </p>
        </div>
      </div>
    </footer>
  );
}